<template>
  <LayoutPrimary>
    <div :style="containerStyle">
      <div :style="headerContainerStyle">
        <HeaderLargePrimary :style="headerStyle">
          {{ tenantName }}
        </HeaderLargePrimary>
        <ButtonPrimary v-if="isAdmin"
                       :style="buttonStyle"
                       @click="openModalToInviteUsers">
          Invite People
        </ButtonPrimary>
      </div>
      <div :style="tableHeaderContainerStyle">
        <div :style="searchBoxContainerStyle">
          <SearchBoxPrimary placeholder="Search"
                            v-model="input"
                            :disabled="isRequesting"
                            @search="searchUsers" />
        </div>
        <div :style="tenantUsersCountContainerStyle">
          Total count <span :style="tenantUsersCountStyle">{{ tenantUsersCount }}</span>
        </div>
      </div>
      <template v-if="tenantUsersLoaded">
        <div :style="tableContainerStyle">
          <UsersTable :tenantUsers="tenantUsers" />
        </div>
        <div :style="paginationContainerStyle">
          <PaginationPrimary v-model="currentPage"
                             :disabled="isRequesting"
                             :pageNum="tenantUsersPageNum" />
        </div>
      </template>
      <template v-else>
        <div :style="loaderContainerStyle">
          <LoaderPrimary :loading="true" />
        </div>
      </template>
    </div>
  </LayoutPrimary>
</template>

<script>
  import ButtonPrimary from '@modules/button/button-primary'
  import HeaderLargePrimary from '@modules/text/header-large-primary'
  import LayoutPrimary from '@modules/v2/layout/layout-primary'
  import LoaderPrimary from '@modules/loader/loader-primary'
  import PaginationPrimary from '@modules/pagination/pagination-primary'
  import SearchBoxPrimary from '@modules/search-box/search-box-primary'
  import UsersTable from '@workspace/modules/users-table'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters, mapState } from 'vuex'
  import { MODAL_WINDOW_NAMES } from '@js/constants'

  export default {
    name: 'WorkspaceView',
    components: {
      ButtonPrimary,
      HeaderLargePrimary,
      LayoutPrimary,
      LoaderPrimary,
      PaginationPrimary,
      SearchBoxPrimary,
      UsersTable,
    },
    data: function () {
      return {
        buttonStyle: {
          minWidth: '121px',
        },
        containerStyle: {
          margin: '32px auto 0 auto',
          maxWidth: Layout.container.primary.maxWidth,
          padding: Layout.container.primary.padding,
          width: '100%',
        },
        currentPage: 1,
        headerContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
        },
        headerStyle: {
          display: 'block',
        },
        input: '',
        isRequesting: false,
        loaderContainerStyle: {
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
          minHeight: '320px',
          width: '100%',
        },
        paginationContainerStyle: {
          display: 'flex',
          justifyContent: 'center',
          margin: `${Layout.space.lg} 0`,
          width: '100%',
        },
        searchBoxContainerStyle: {
          margin: `0 ${Layout.space.md} 0 0`,
          maxWidth: '240px',
        },
        tableContainerStyle: {
          margin: `${Layout.space.md} 0 0 0`,
        },
        tableHeaderContainerStyle: {
          alignItems: 'flex-end',
          display: 'flex',
          justifyContent: 'space-between',
          margin: '28px 0 0 0',
        },
        tenantUsersCountContainerStyle: {},
        tenantUsersCountStyle: {
          fontWeight: FontStyle.weight.xl,
        },
        tenantUsersLoaded: false,
      };
    },
    created: async function () {
      await this.fetchTenantUsers(1);
      this.tenantUsersLoaded = await true;
    },
    computed: {
      ...mapGetters('tenantUser', ['isAdmin',]),
      ...mapGetters('tenantUsers', ['tenantUsersPageNum']),
      ...mapState({
        tenant: state => state.tenant,
        tenantName: state => state.tenant.name,
        tenantUsers: state => state.tenantUsers.tenantUsers,
        tenantUsersCount: state => state.tenantUsers.count,
        page: state => state.tenantUsers.page,
        pageSize: state => state.tenantUsers.pageSize,
      }),
    },
    methods: {
      fetchTenantUsers: async function (page) {
        try {
          this.isRequesting = true;
          const payload = {
            page: page,
            pageSize: this.pageSize,
            ...(this.input.trim().length > 0 ? { search: this.input } : {}),
          };

          await this.$store.dispatch('tenantUsers/fetchTenantUsers', payload);
          this.isRequesting = await false;
        } catch (error) {
          this.isRequesting = false;
          this.$store.commit('notification/setWarning', 'Failed to load users');
          console.error(error);
        }
      },
      openModalToInviteUsers: function () {
        const params = {
          tenant: this.tenant,
        };
        this.$modal.show(MODAL_WINDOW_NAMES.INVITE_TO_TENANT_PRIMARY, params);
      },
      searchUsers: async function () {
        if (this.currentPage === 1) {
          await this.fetchTenantUsers(1);
        } else {
          this.currentPage = 1;
        }
      },
    },
    watch: {
      currentPage: async function (newVal, oldVal) {
        await this.fetchTenantUsers(newVal);
        await window.scrollTo(0, 0);
      },
    },
  };
</script>
